export default {
    getCurrentHash(state) {
        return state.currentHash;
    },
}
